import React, { useState } from "react";
import { AsyncPaginate } from 'react-select-async-paginate';
import { FormError } from "../../FormError";
import  defaultConfig  from "../../../config/Config";
import NumberField  from "../NumberField";
import { getList } from "../../../slices/ProductsSlice";
import { useDispatch } from "react-redux";
import { Controller } from "react-hook-form";
const OrderProducts = function (props) {
    const {
        errors,
        setValue,
        getValues,
        control,
        addProductList,
        removeProduct,
        productCount,
        index,
        register
    } = props;
    const dispatch = useDispatch();
    const [selectedProduct, setSelectedProduct] = useState('');
    const [requestInProgress, setRequestInProgress] = useState(false);
    const [perProductPrice, setPerProductPrice] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0)

    function addProduct() {
        addProductList() 
    }

    function remove(index) {
        removeProduct(index)
    }

    function onChangeQuantity(e) {
        const price = getValues(`product`)?.[index]?.price
        const total = (price * e.target.value).toFixed(2)
        setValue(`product.${index}.totalAmount`, total)
        setTotalAmount(total);

        document.dispatchEvent(new CustomEvent('calculate-total-amount', {}) );

    }

    async function loadProducts( search, loadedOptions, { page } ) {
        if(!requestInProgress){
            setRequestInProgress(true)
            const {meta, payload} = await dispatch(getList({data : {pageLength:defaultConfig.defaultLimit, page: page, searchString: search}}))
            let productList = []
            if(meta.requestStatus === "fulfilled"){
                setRequestInProgress(false)
                productList = payload?.docs.map(({_id: productIds, name, price}) => { return { label:`${name})` , value : productIds, price } })
            }
            
            return {
                options: productList,
                hasMore: productList?.length > 0? true : false,
                additional: {
                    page: page + 1
                }
            };

        }else  {
            return {
                options:[],
                hasMore:true,
                additional: {
                    page: page
                }
            };
        }
    }

    return (
        <div className="d-flex flex-row pt-3 p-0 ">
            <div className="col-3 pr-0">
                <div className="form-group mb-3">
                <Controller
                    control={control}
                    name={`product.${index}.productId`}
                    render={({ field: { value, onChange } }) => (
                        <AsyncPaginate
                            //value={selectedProduct}
                            loadOptions={loadProducts}
                            onChange={ (e)=>{  
                                setSelectedProduct(e.label)
                                setPerProductPrice(e.price)
                                onChange(e.value) 
                                setValue(`product.${index}.name`, e.label)
                            } }
                            additional={{
                                page: 1,
                            }}
                        />
                    )}
                />
                <input type="hidden" className="form-control" {...register(`product.${index}.name`)} />
                {errors.orderFrom && (
                    <FormError message={errors.orderFrom.message} />
                )}
                </div>
            </div>
            <div className="col-2 pr-0">
                <div className="form-group mb-3">
                <NumberField 
                    placeholder="Product Price" 
                    setValue = { setValue } 
                    control = {control} 
                    name = {`product.${index}.price`} 
                    readOnly="readOnly"
                    value = {perProductPrice} 
                    className='input-txt form-control' 
                />  
                {errors.orderFrom && (
                    <FormError message={errors?.orderFrom?.message} />
                )}
                </div>
            </div>   
            <div className="col-2 pr-0">
                <div className="form-group mb-3">
                <NumberField 
                    placeholder = "Order Quantity" 
                    setValue = { setValue } 
                    control = {control} 
                    onCustValueChange = { onChangeQuantity }
                    name = {`product.${index}.quantity`} 
                    className='input-txt form-control' 
                />  
                {errors.orderFrom && (
                    <FormError message={errors?.orderFrom?.message} />
                )}
                </div>
            </div>
            <div className="col-2 pr-0">
                <div className="form-group mb-3">
                <NumberField 
                    placeholder = "Total Amount" 
                    setValue = { setValue } 
                    control = {control} 
                    name = {`product.${index}.totalAmount`} 
                    value = {totalAmount}
                    readOnly = "readOnly"
                    className = 'input-txt form-control' 
                />  
                
                {errors.orderFrom && (
                    <FormError message={errors?.orderFrom?.message} />
                )}
                </div>
            </div>
            <div className="col-2 pr-0">
                <button type="button" onClick={ addProduct } className="btn btn-lg btn-success"><i className="fa fa-plus"></i></button>
                &nbsp;
                <button type="button" disabled={productCount === 1? true : false } onClick={ (e) => remove(index) } className="btn btn-lg btn-danger"><i className="fa fa-trash"></i></button>
            </div>
        </div>
    )
}

export default OrderProducts;